@if (recommendationItems()?.length) {
  <mobi-split-button-section
    class="view-enter-animation"
    [title]="title()"
    [description]="description() || ''"
    [content]="content"
    [items]="recommendationItems()"
  >
    <ng-template #content let-currentItem="currentItem">
      <div class="mobi-ui-grid is-centered relative">
        @for (
          recommendation of recommendations();
          track recommendation.tabLabel ?? $index
        ) {
          <div
            class="mobi-ui-col-1/1 md:mobi-ui-col-3/4 split-button-item"
            [ngClass]="{
              'is-hidden': currentItem() !== recommendation.tabLabel,
            }"
          >
            <div class="mobi-ui-grid">
              <div
                class="mobi-ui-col-1/1 xs:mobi-ui-col-4/8 self-stretch flex items-center"
              >
                <div>
                  @if (recommendation.badge) {
                    <div
                      class="view-enter-animation gap-2 mobi-ui-badge-major mobi-ui-inline-flex text-read"
                    >
                      <mobi-ui-icon-major name="badge" size="sm" />
                      {{
                        recommendation.badge + '_badge'
                          | texts: { context: 'frontend', default: 'Empfehlung' }
                      }}
                    </div>
                  }
                  @if (recommendation.title) {
                    <mobi-heading-select
                      class="block view-enter-animation"
                      [title]="recommendation.title"
                      [headingType]="getTitleSize(recommendation)"
                      headingStyle="h3"
                    />
                  }
                  @if (recommendation.description) {
                    <mobi-text
                      class="mobi-ui-font-size-150 block view-enter-animation"
                      [data]="recommendation.description"
                    />
                  }
                  @if (recommendation.items && breakpoint.xsAndLarger()) {
                    <p
                      class="mobi-ui-font-bold mobi-ui-font-size-150 view-enter-animation mobi-ui-margin-b-sm mobi-ui-margin-t-md"
                    >
                      {{ recommendation.itemsTitle }}
                    </p>
                    <div class="is-wrap mobi-ui-flow-x-sm">
                      @for (item of recommendation.items.split('|'); track $index) {
                        <div>
                          @if (item) {
                            <div
                              class="view-enter-animation gap-2 recommendation-item mobi-ui-card-muted is-small is-row !mt-0 mobi-ui-font-size-100"
                            >
                              <mobi-ui-icon-major
                                name="tik_checkbox"
                                size="sm"
                                class="mobi-ui-ink-green"
                              />
                              {{ item }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              @if (recommendation.teaser) {
                <div
                  class="mobi-ui-col-1/1 xs:mobi-ui-col-4/8 xl:mobi-ui-col-3/8 xl:mobi-ui-offset-1/8"
                >
                  <mobi-teaser
                    class="block view-enter-animation teaser-has-background"
                    [published]="recommendation.teaser.published"
                    [teaserTitle]="recommendation.teaser.teaserTitle"
                    [teaserText]="recommendation.teaser.teaserText"
                    [teaserImage]="recommendation.teaser.teaserImage"
                    [teaserUrl]="recommendation.teaser.url | extractUrl"
                    [secondaryActionUrl]="
                      recommendation.teaser.calculatorCta
                        | extractUrl
                        | calcUrl: (recommendation.teaser.calculatorCtaAuth | extractUrl)
                    "
                    [secondaryActionTarget]="
                      recommendation.teaser.calculatorCta?.options?.attributes?.target
                    "
                    [secondaryActionText]="recommendation.teaser.calculatorCta?.title"
                    secondaryActionIcon="calculator"
                    [bundle]="recommendation.teaser.bundle"
                    [teaserTitleSize]="getTeaserTitleSize(recommendation)"
                    teaserTitleStyle="h5"
                    [trackingId]="recommendation.teaser.uuid"
                  />
                </div>
              }
            </div>
          </div>
        }
      </div>
    </ng-template>
  </mobi-split-button-section>
}
